module.exports = __webpack_public_path__ + "595b47ea77425366cc0b24a3c8b2d571.svg";